import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {Color} from "../types/Color";

export const useGetColors = (dealerID: number, prodQteGrpID: number, pricingDate: Date, zipCode: string) => {
    const {data, isLoading} = useQuery({
        queryKey: ['ee-pro-colors', prodQteGrpID, dealerID, zipCode],
        queryFn: async () => await apiClient.get('ee-pro/colors?dealerID=' + dealerID + '&prodQteGrpID=' + prodQteGrpID + '&pricingDate=' + pricingDate.toISOString() + '&zipCode=' + zipCode) as Color[],
        enabled: prodQteGrpID > 0,
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
